const getAuthRedirectUrl = (asPath: string, redirect: string) => {
  const redirectUrl = redirect === "" ? asPath : redirect;
  switch (redirectUrl) {
    case "/login":
    case "/register":
      return "/";
    default:
      return redirectUrl;
  }
};

export default getAuthRedirectUrl;
